import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AssociationsModal, HelperWrapper } from 'src/components'
import { ETranslationNs, IImpactByIdRawRespDto } from 'src/types'

import useStyles from 'src/components/associations/styles'
import { ConnectionsList } from './connections-list.component'
import { Typography } from '@mui/material'

interface Props {
  description: string
  handleSelectItem: (value: string) => void
  connections: IImpactByIdRawRespDto[]
  modalContentNode?: ReactNode
  error?: string
  disable?: boolean
}

export const ScanImpactAssociation = ({
  description,
  handleSelectItem,
  connections,
  modalContentNode,
  error,
  disable,
}: Props) => {
  const [t] = useTranslation(ETranslationNs.Navbar)
  const classes = useStyles({})
  const [open, setOpen] = useState(false)

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  const selectionCount = connections.length

  return (
    <div className={classes.bigContainer}>
      <div className={classes.text}>{description}</div>
      {/* {!disable && (
        <div className={classes.textCounter}>
          {selectionCount} {t('impacts-header-title.v')}
        </div>
      )} */}
      <ConnectionsList items={connections} handleSelectItem={handleSelectItem} disable={disable} />
      <AssociationsModal
        modalContentNode={modalContentNode}
        open={open}
        handleCloseModal={handleCloseModal}
      />
      <input
        width={'100%'}
        name="image"
        accept="image/*"
        id="impact-association"
        type="checkbox"
        multiple
        hidden
        onChange={handleOpenModal}
      />
      {error && (
        <Typography className={classes.errorText} color="error">
          <HelperWrapper t={error} />
        </Typography>
      )}
    </div>
  )
}
